export default function (category: string) {
  switch (category) {
    case 'Queer':
      return 'QueerfemTiny'
    case 'Frauensendungen':
      return 'WomenTiny'
    case 'Wiederholung':
      return 'Repetition'
    case 'Feministisch':
      return 'LoudSpeakerSmall'
    default:
      break
  }
}
